module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-tokyo-2-844735af4f6869cfc31088c8fc571b58.png";